import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import router from './router'
import {VueSelect} from "vue-select";
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faBolt, faBroadcastTower, faCarBattery, faCheckCircle, faEdit, faExclamationTriangle, faFan, faFireAlt, faHdd, faInfoCircle, faPlug, faTools, faTrash, faUserCog, faVolumeMute} from "@fortawesome/free-solid-svg-icons";

library.add([faBroadcastTower, faHdd, faEdit, faInfoCircle, faExclamationTriangle, faCheckCircle, faFireAlt, faCarBattery, faTools, faPlug, faUserCog, faBolt, faFan, faVolumeMute, faTrash]);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-select', VueSelect);

Vue.config.productionTip = false;

// Add auth key to all requests
axios.interceptors.request.use((config) => {
    let key = localStorage.getItem("authKey");
    if (key !== null) {
        config.headers["X-Auth-Token"] = key;
    }
    return config;
});

// Redirect to login on 401 error
axios.interceptors.response.use(null, (error) => {
    let response = error.response;
    if (response && response.status === 401 &&
        error.config.url.endsWith("/user/login") === false &&
        error.config.url.endsWith("/user/userInfo") === false) {
        localStorage.removeItem("authKey");
        router.push("login");
        return;
    }
    return Promise.reject(error);
});

new Vue({
    data() {
        return {
            userInfo: {}
        };
    },
    render: h => h(App),
    router
}).$mount('#app');
